import React, {useState, useEffect} from 'react';

import DesktopContainer from './DesktopContainer';
import MobileContainer from './MobileContainer';
import { useQuery} from '../../shared/useQuery';
import { useTranslation } from 'react-i18next';
import { MediaContextProvider} from './Media';

import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";

const ResponsiveContainer:React.FC<React.PropsWithChildren<{}>> = ( props:any ) => {
  const { t, i18n } = useTranslation();
  const [initialized, setInitialized] = useState(false);
  const userLanguage = useQuery().get("lang");
  if (userLanguage!==null && userLanguage.toLocaleLowerCase()!==i18n.language.toLocaleLowerCase()) {
    i18n.changeLanguage(userLanguage);
  }

  useEffect(() => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true") {
      
      handleAcceptCookie();
    }
  }, []);

  

  const handleAcceptCookie = () => {
    setInitialized(true);
  };

  const handleDeclineCookie = () => {
    //remove google analytics cookies
    setInitialized(false);

    Cookies.remove("ovsc-tel");
    Cookies.remove("ovsc-email");
    Cookies.remove("ovsc-userName");
  };

  let consent = null;
  if (!initialized) {
    consent =  <CookieConsent
      enableDeclineButton
      debug={true}
      location="bottom"
      style={{ background: '#000', textAlign:"left"}}
      buttonStyle={{color: '#000', background: '#fff', fontSize: "14px"}}
      buttonText={t("cookies.button")}
      declineButtonText={t("cookies.declineButton")}
      onAccept={handleAcceptCookie}
      onDecline={handleDeclineCookie}
      expires={365}
      overlay
    >
      {t("cookies.text")}
    </CookieConsent>
  }


  return (
    
    <MediaContextProvider>
      <DesktopContainer>{props.children}</DesktopContainer>
      <MobileContainer>{props.children}</MobileContainer>
      {consent}
    </MediaContextProvider>
  );
}

export default ResponsiveContainer;
